import React, { ReactElement } from "react";

import { appendComponentWithNoBr } from "utils/appendComponentWithNoBr";

import { Container, Heading, Address, HeadingArrow } from "./Office.styled";
import OfficeProps from "./OfficeProps";

const Office = ({
    officeName,
    addressRow1,
    city,
    postalCode,
    url,
    className,
    gtmClickType = "office_search",
}: OfficeProps): ReactElement => {
    return (
        <Container className={className}>
            <Heading title={officeName} url={url} gtmClickType={gtmClickType}>
                {appendComponentWithNoBr(
                    officeName,
                    <HeadingArrow
                        icon={"longArrowRight28"}
                        aria-hidden="true"
                    />,
                )}
            </Heading>
            <Address>
                {addressRow1}
                {(postalCode || city) && `,`}
                {postalCode && ` ${postalCode}`}
                {city && ` ${city}`}
            </Address>
        </Container>
    );
};

export default React.memo(Office);
